<div class="common-questions">
  <p>Common questions</p>
  @for (question of commonQuestions$ | ngrxPush; track question) {
    <div class="common-question" (click)="questionClicked(question)">
      <div>{{ question }}</div>
      <terra-icon icon="sparkle" variant="fill" size="20"></terra-icon>
    </div>
  }
</div>
